import SVG from './SVG'

export const MapSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="map">
        <path
          fillRule="evenodd"
          d="M8 1a.995.995 0 0 0-.511.14L.504 5.132A1 1 0 0 0 0 6v16a1 1 0 0 0 1.496.868l6.535-3.734 7.504 3.751a.994.994 0 0 0 .976-.026l6.985-3.99A1 1 0 0 0 24 18V2a1 1 0 0 0-1.496-.868l-6.536 3.734-7.503-3.751A.996.996 0 0 0 8 1Zm9 19.277 5-2.857V3.723L17 6.58v13.697ZM15 6.618l-6-3v13.764l6 3V6.618ZM2 6.58l5-2.857V17.42l-5 2.857V6.58Z"
          className="Union"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
